import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { Logger } from '../logger/logger.service';
import { SwalService } from '../services/swal.service';
import { ToastsService, ToastsParamsI } from '../services/toasts.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

const log = new Logger('AuthInterceptorService');
declare var provab: any;
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  toastsParams: ToastsParamsI;

  constructor(
    private swalService: SwalService,
    private toastsService: ToastsService,
    private router: Router,
    private ngxLoadService: NgxUiLoaderService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = JSON.parse(sessionStorage.getItem('b2cUser'));
    let clonedAuthReq = req;
    const hdr = {};

    if (!req.headers.has('Content-Type')) {
      clonedAuthReq = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
    }
    if (token) {
      clonedAuthReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token['access_token'])
      });
    }

    const foo = {};
    const started = Date.now();
    return next.handle(clonedAuthReq).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            foo['api_response_status'] = event.status;
            foo['api_response_url'] = event.url;
            foo['api_response_message'] = event.statusText;
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.handleAuthError();
            return error;
          } else {
            return this.handleError(error)
          }

          foo['api_response_status'] = error.status;
          foo['api_response_url'] = error.url || '';
          foo['api_response_message'] = error.statusText;
          this.toastsParams = { text: `Internal server error, Please try later`, type: 'error' };
          // this.toastsService.toast(this.toastsParams);
          console.error(error);
          throw error;
        }
      ),
      // Log when response observable either completes or errors
      finalize(() => {
        const elapsed = Date.now() - started;
        foo['api_response_time'] = elapsed;
        log.debug(foo);
      })
    );


  }

  handleError(error: HttpErrorResponse): Observable<any> {
    return throwError(error);
  }

  private handleAuthError() {
    this.ngxLoadService.stop();
    sessionStorage.clear();
    if (window.location.href.indexOf("user-management") > -1) {
      this.reloadCurrentRoute();
    }
  }

  reloadCurrentRoute() {
  }
}
